import React from 'react';

import cn from '@/helpers/utils/classNames';

import { HeadingProps } from '../propTypes';
import { headingStyles } from '../styles';

const HeadingFour = ({ className, variant = 'primary', children, ...rest }: HeadingProps) => {
  return (
    <h3
      className={cn(
        headingStyles({
          color: variant,
        }),
        'sm:text-lg md:text-[1.25rem] lg:text-xl xs:text-[1rem] xxs:text-[0.9rem]',
        className
      )}
      {...rest}
    >
      {children}
    </h3>
  );
};

export default HeadingFour;
